import * as React from "react"
import {fontFaceMoontime,headStyle,bgStyleOne,round,barlow} from './meetManager.module.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const MeetManager = ({managerName,managerTitle,apartmentName,managerImage,children})=>{
    const image = managerImage ? getImage(managerImage.gatsbyImageData) : false;
    return(
        <section className={bgStyleOne} id="meet_manager">
            <div className=" container">
                <div className="columns is-vcentered is-mobile is-multiline">
                    <div className="column is-two-thirds-desktop is-full-mobile">
                        <h1 className={fontFaceMoontime+' '+headStyle}>Meet Your Community Manager</h1>
                        
                        <p>{children}</p>
                        
                    </div>
                    <div className="column has-text-centered">
                        {image && <GatsbyImage image={image} alt="" className={round} style={{maxWidth:'200px'}}/>}
                        <h2 className={barlow+" is-size-4"}>
                            {managerName} 
                        </h2>
                        <p className={barlow}>{managerTitle}<br /><span style={{position:'relative',top:'-5px'}}>{apartmentName}</span></p>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default MeetManager
